// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '100'
  }, {
    prop: 'background_image',
    label: '',
    img: true,
    width: '150'
  }, {
    prop: 'name',
    Object: 'value',
    label: '',
    width: '150'
  }, {
    prop: 'name_en',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'required_points',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value',
    width: '150'
  }]
}
